import gql from "graphql-tag";

import { MESSAGE_DETAILS_FRAGMENT } from "./fragments";

export const ON_MESSAGE_CHANGED = gql`
  subscription onMessageChanged($numberUuid: ID!, $chatUuid: ID!) {
    onMessageChanged(numberUuid: $numberUuid, chatUuid: $chatUuid) {
      ...MessageDetails
    }
  }

  ${MESSAGE_DETAILS_FRAGMENT.query}
`;
